import api from '../api'
import { slugify, windowResize } from '../utils'

export const dispatchGamesList = (gamesList) => ({
	type: 'GAMES_LIST',
	payload: gamesList
});

export const dispatchEndings = (endings) => ({
	type: 'ENDINGS',
	payload: endings
});

export const dispatchNoResults = (no_results) => ({
	type: 'NO_RESULTS',
	payload: no_results
});

export const dispatchParticipated = (participated) => ({
	type: 'PARTICIPATED',
	payload: participated
});

export const dispatchDraws = (draws) => ({
	type: 'DRAWS',
	payload: draws
});

export const setParticipation = (participated) => dispatch => {
		dispatch(dispatchParticipated(participated));
}

export const getDraws = () => dispatch => {
	return api.getDraws().then((response) => {
		const drawsList = response['data'];
		dispatch(dispatchDraws(drawsList));
		windowResize();
	});
}

export const getEvents = () => dispatch => {
	return api.getEvents().then((response) => {
		let gamesList = {};
		let endings = {};
		if(typeof response['data'] === 'undefined'){dispatch(dispatchNoResults(true));return false;}
		const competitionsList = response['data']['competitions'];
		// build games list
		if(competitionsList==null){dispatch(dispatchNoResults(true));return false;}
		for (let c = 0; c < competitionsList.length; c++) {
			if(competitionsList[c]['markets'] ==  null){continue;}
			let ckeys = Object.keys(competitionsList[c]['markets']);
			for (let cm = 0; cm < ckeys.length; cm++) {
				let name = 'multi-market';
				let m = ckeys[cm];
				if (gamesList[name] === undefined) { gamesList[name] = []; }
				gamesList[name].push({
					"id": competitionsList[c]['id'] + '-' +
						competitionsList[c]['markets'][m]['event_id'] + '-' +
						competitionsList[c]['markets'][m]['match_id'] + '-' +
						competitionsList[c]['markets'][m]['market_id'], // make id unique under grouping
					"competition_id": competitionsList[c]['id'],
					"market_name": slugify(competitionsList[c]['markets'][m]['market_name']),
					"jackpot": competitionsList[c]['jackpot'],
					"event_id": competitionsList[c]['markets'][m]['event_id'],
					"draw_date": competitionsList[c]['draw_date'],
					"match_id": competitionsList[c]['markets'][m]['match_id'],
					"name": competitionsList[c]['markets'][m]['match_name'],
					"match_date": competitionsList[c]['markets'][m]['match_date'],
					"selectedballs": [],
					"outcome": competitionsList[c]['markets'][m]['outcomes']
				});

				if (endings[name] === undefined) { endings[name] = competitionsList[c]['draw_date']; }
			}
		}

		if(Object.keys(gamesList).length === 0){dispatch(dispatchNoResults(true));return false;}

		dispatch(dispatchGamesList(gamesList));
		dispatch(dispatchNoResults(false));
		dispatch(dispatchEndings(endings));
		windowResize();
	});
}

export const setTimeRemaining = (timeRemaining) => ({
  type: 'SET TIME REMAINING',
  payload: timeRemaining
})



// WEBPACK FOOTER //
// ./actions/eventsAction.js